import React from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import App from './App'
import './styles/global.css'

const rootElement = document.getElementById('root')

// If react-snap pre-rendered HTML is present, hydrate it. Otherwise render
// fresh. This dual path lets us run both as a normal SPA in dev and as a
// hydrated pre-rendered site in production (better SEO + faster first paint).
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

if (rootElement && rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, tree)
} else {
  createRoot(rootElement).render(tree)
}
